( function () {
    'use strict';
    jQuery.extend( true, e4.settings, {
        require: {
            moment: {
                url: '//cdnjs.cloudflare.com/ajax/libs/moment.js/2.24.0/moment.min.js',
                fallback: '/Files/Templates/Designs/sro/_assets/js/vendor/moment.min.js',
                callback: null
            },
            datepicker: {
                url: '//cdnjs.cloudflare.com/ajax/libs/bootstrap-datepicker/1.9.0/js/bootstrap-datepicker.min.js',
                fallback: '/Files/Templates/Designs/sro/_assets/js/vendor/datepicker.js',
                callback: null
            }
        },
        custom: {
            hotspots: {
                reportGenerationUrl: '/system/data/sro-report',
                liveUpdateInterval: 10000,
                range: [
                    {
                        duration: 12,
                        key: 'hours'
                    },
                    {
                        duration: 1,
                        key: 'days'
                    },
                    {
                        duration: 2,
                        key: 'days'
                    },
                    {
                        duration: 1,
                        key: 'weeks'
                    },
                    {
                        duration: 2,
                        key: 'weeks'
                    },
                    {
                        duration: 1,
                        key: 'months'
                    }
                ],
                colors: [
                    '#36c',
                    '#dc3912',
                    '#f90',
                    '#109618',
                    '#909',
                    '#0099c6',
                    '#d47',
                    '#6a0',
                    '#b82e2e',
                    '#8b0707'
                ]
            },
            datepicker:{
                dates:{
                    da:{
                        days: [
                            'Søndag','Mandag','Tirsdag','Onsdag','Torsdag','Fredag','Lørdag'
                        ],
                        daysShort: [
                            'Søn','Man','Tir','Ons','Tor','Fre','Lør'
                        ],
                        daysMin: [
                            'Sø','Ma','Ti','On','To','Fr','Lø'
                        ],
                        months: [
                            'Januar','Februar','Marts','April','Maj','Juni','Juli','August','September','Oktober','November','December'
                        ],
                        monthsShort: [
                            'Jan','Feb','Mar','Apr','Maj','Jun','Jul','Aug','Sep','Okt','Nov','Dec'
                        ],
                        today: 'I Dag',
                        weekStart: 1,
                        clear: 'Nulstil',
                        format: 'dd/mm/yyyy',
                        monthsTitle: 'Måneder'
                    }
                }
            }
        }
    } );
}() );



